export default "__VITE_ASSET__wtDxcNPf__"